import React, { useState } from "react";
import { Typography, Grid, TextField, Card, CardContent, IconButton, Button, Box } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { useFormikContext } from "formik";
import ReusableDialog from "../../../../common/dialog/dialog";

const ProfessionalContacts = ({ professionals, setProfessionals }) => {
  const { values, handleChange, handleBlur, touched, errors, setFieldValue } = useFormikContext();
  const [openProf, setProfOpen] = useState(false);
  const [newProfessional, setNewProfessional] = useState({
    profPosition: "",
    profName: "",
    profMobilePhone: "",
    profEmail: "",
  });

  // Handler for input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewProfessional((prevProfessional) => ({
      ...prevProfessional,
      [name]: value,
    }));
  };

  // Handler for phone input change
  const handlePhoneChange = (phone) => {
    setNewProfessional((prevProfessional) => ({
      ...prevProfessional,
      profMobilePhone: phone,
    }));
  };

  // Handler for adding a new professional
  const handleAddProfessional = () => {
    setProfessionals((prevProfessionals) => [...prevProfessionals, newProfessional]);
    setNewProfessional({
      profPosition: "",
      profName: "",
      profMobilePhone: "",
      profEmail: "",
    });
    setProfOpen(false); // Close the dialog after adding the professional
  };

  // Check if all fields are filled
  const isAddButtonDisabled = !(
    newProfessional.profPosition &&
    newProfessional.profName &&
    newProfessional.profMobilePhone &&
    newProfessional.profEmail
  );

  return (
    <>
      <Typography sx={{ fontSize: "18px", color: "black" }} mt={5}>
        Professional Contacts
      </Typography>
      <Typography sx={{ fontWeight: "bold", fontSize: "14px", color: "black" }} mt={1}>
        Social Worker details
      </Typography>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={8}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
            Social Worker
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter your Social Worker'
            name='socialWorker'
            value={values.socialWorker}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.socialWorker && Boolean(errors.socialWorker)}
            helperText={touched.socialWorker && errors.socialWorker}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={6}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
            Mobile Phone no
          </Typography>
          <PhoneInput
            country={"gb"} // Default country set to Great Britain
            value={values.mobilePhone}
            onChange={(phone) => setFieldValue("mobilePhone", phone)}
            onBlur={handleBlur}
            inputProps={{
              name: "mobilePhone",
              required: true,
            }}
            containerStyle={{ width: "100%" }}
            inputStyle={{
              width: "100%",
              height: "55px",
              fontSize: "16px",
            }}
          />
          {touched.mobilePhone && errors.mobilePhone && (
            <Typography color='error' variant='caption'>
              {errors.mobilePhone}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
            Email
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter your Email'
            name='email'
            type='email'
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.email && Boolean(errors.email)}
            helperText={touched.email && errors.email}
          />
        </Grid>
      </Grid>

      {/* Professional Contacts Section */}
      <Typography sx={{ fontWeight: "bold", fontSize: "14px", color: "black" }} mt={1}>
        YOT Worker Details
      </Typography>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={8}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
            YOT Worker
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter your YOT Worker'
            name='yotWorker'
            value={values.yotWorker}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.yotWorker && Boolean(errors.yotWorker)}
            helperText={touched.yotWorker && errors.yotWorker}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={6}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
            Mobile Phone no
          </Typography>
          <PhoneInput
            country={"gb"} // Default country set to Great Britain
            value={values.yotMobilePhone}
            onChange={(phone) => setFieldValue("yotMobilePhone", phone)}
            onBlur={handleBlur}
            inputProps={{
              name: "yotMobilePhone",
              required: true,
            }}
            containerStyle={{ width: "100%" }}
            inputStyle={{
              width: "100%",
              height: "55px",
              fontSize: "16px",
            }}
          />
          {touched.yotMobilePhone && errors.yotMobilePhone && (
            <Typography color='error' variant='caption'>
              {errors.yotMobilePhone}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
            Email
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter your Email'
            name='yotEmail'
            type='email'
            value={values.yotEmail}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.yotEmail && Boolean(errors.yotEmail)}
            helperText={touched.yotEmail && errors.yotEmail}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={10}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left' mb={2}>
            Other
          </Typography>
          <Grid container spacing={2}>
            {professionals.map((professional, index) => (
              <Grid item lg={6} xs={12} key={index}>
                <Card className='social-worker-card'>
                  <CardContent>
                    <Grid container spacing={2} alignItems='center'>
                      <Grid item xs={10}>
                        <Typography variant='subtitle1' className='role-title'>
                          {professional.profPosition}
                        </Typography>
                        <Grid container spacing={1} alignItems='center'>
                          <Grid item>
                            <Typography variant='body2'>{professional.profName}</Typography>
                          </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='center'>
                          <Grid item>
                            <Typography variant='body2'>{professional.profMobilePhone}</Typography>
                          </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='center'>
                          <Grid item>
                            <Typography variant='body2'>{professional.profEmail}</Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={2} align='right'>
                        <IconButton>
                          <EditIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Add More Button */}
          <Button color='primary' mt={2} onClick={() => setProfOpen(true)}>
            <AddIcon /> Add more
          </Button>

          {/* Dialog for Adding New Professional */}
          <ReusableDialog
            isOpen={openProf}
            onClose={() => setProfOpen(false)}
            title='Add another professional person?'
            contentText='Add the relevant details to the fields to add another person to the involved parties.'
            onSubmit={handleAddProfessional}
            submitText='Add'
            cancelText='Cancel'
            disable={isAddButtonDisabled}
          >
            <Box mt={2}>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={6}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Position
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder='Enter the position'
                    name='profPosition'
                    value={newProfessional.profPosition}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={6}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Name
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder='Enter Name of the person'
                    name='profName'
                    value={newProfessional.profName}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={6}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Mobile Phone no
                  </Typography>
                  <PhoneInput
                    country={"gb"}
                    value={newProfessional.profMobilePhone}
                    onChange={handlePhoneChange}
                    containerStyle={{ width: "100%" }}
                    inputStyle={{ width: "100%", height: "55px", fontSize: "16px" }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={1} mb={3}>
                <Grid item xs={12} sm={6}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Email
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder='Enter your Email'
                    name='profEmail'
                    type='email'
                    value={newProfessional.profEmail}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
            </Box>
          </ReusableDialog>
        </Grid>
      </Grid>
    </>
  );
};

export default ProfessionalContacts;
